import { AppColors } from "./AppColors";

export const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };
export const plusBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
export const delBtn = { color: AppColors.red, width: 20, height: 20 };
export const eyeBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
